// This component has been replaced with LeaveManagement.js for comprehensive HR leave management
// Redirecting to the new Leave Management Dashboard

import LeaveManagement from './LeaveManagement';
const Leave = () => {
  return <LeaveManagement />;
};

export default Leave;
